import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from 'src/api/apiClient';
import { GET_CREDIT, GET_USER_CUSTOMER_DETAILS } from 'src/constants/httpEndPoints';

export const userLoginAction = createAsyncThunk(
  'login/user-login',
  async ({ token }: { token: string }) => {
    return token;
  },
);
export const userEmailAction = createAsyncThunk(
  'login/user-email',
  async ({ userEmail }: { userEmail: string }) => {
    return userEmail;
  },
);
export const userRoleAction = createAsyncThunk(
  'login/user-role',
  async ({ userRole }: { userRole: string }) => {
    return userRole;
  },
);
export const userClientAddAction = createAsyncThunk(
  'login/customers-add',
  async ({
    clientData,
  }: {
    clientData: [{ CustomerKey: string; CustomerName: string; key: string }];
  }) => {
    return clientData;
  },
);
export const setCurrentClientSelected = createAsyncThunk(
  'login/client-selected',
  async ({ clientIndex }: { clientIndex: number }) => {
    return clientIndex;
  },
);
export const setCurrentClientId = createAsyncThunk(
  'login/client-id',
  async ({ clientId }: { clientId: string }) => {
    return clientId;
  },
);
export const setCurrentClientIndex = createAsyncThunk(
  'login/client-index',
  async ({ clientIndex }: { clientIndex: number }) => {
    return clientIndex;
  },
);
export const setCurrentViewAction = createAsyncThunk(
  'login/current-view',
  async ({ currentView }: { currentView: string }) => {
    return currentView;
  },
);
export const setIsCmpAccessAction = createAsyncThunk(
  'login/cmp-access',
  async ({ cmpAccess }: { cmpAccess: string }) => {
    return cmpAccess;
  },
);
export const setUserTimezone = createAsyncThunk(
  'login/user-timezone',
  async ({ timezone }: { timezone: string }) => {
    return timezone;
  },
);
export const setCmpNameAction = createAsyncThunk(
  'login/cmp-name',
  async ({ cmpName }: { cmpName: string }) => {
    return cmpName;
  },
);
export const setTrailPeriodAction = createAsyncThunk(
  'login/trail-period',
  async ({ trialPeriod }: { trialPeriod: number }) => {
    return trialPeriod;
  },
);
export const setUserTenantTypeAction = createAsyncThunk(
  'login/user-tenant-type',
  async ({ tenantType }: { tenantType: string }) => {
    return tenantType;
  },
);
export const refreshCustomerListAction = createAsyncThunk(
  'login/refresh-customer-list',
  async ({ email }: { email: string }) => {
    const res = await apiClient.post(GET_USER_CUSTOMER_DETAILS, { email });
    return res.data as [{ CustomerKey: string; CustomerName: string; key: string }];
  },
);
